import { LegacyAppApiClient } from '@guiker/authentication-shared'
import { useConfig } from '@guiker/config-context'

export const useAuthenticationAppApiClient = () => {
  const { legacyApiUrl: baseUrl } = useConfig()
  return LegacyAppApiClient(baseUrl, console)
}
